import React from "react";

const PDFContext = React.createContext(false);

export default PDFContext;
